export default __webpack_public_path__ + "static/media/space.71174e3e.png";